'use client';

import R2Image from '@/components/ui/R2Image';
import type { ConcernCard } from '@/types/components/whatIsYourConcern';

import { getScanCategoryIcon } from './scanCategoryIcons';

type Props = {
  concerns: ConcernCard[];
  activeIndex: number;
  onSelect: (index: number) => void;
};

const ScanCategoryTabs = ({ concerns, activeIndex, onSelect }: Props) => {
  return (
    <div
      role="tablist"
      aria-label="Scan categories"
      className="flex flex-wrap justify-center gap-4"
    >
      {concerns.map((concern, index) => {
        const label = concern.heading.content;
        const icon = getScanCategoryIcon(label);
        const isActive = index === activeIndex;

        return (
          <button
            key={label}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onSelect(index)}
            className={`flex w-30 cursor-pointer flex-col items-center gap-2 rounded-xl border bg-white px-3 py-4 text-center transition duration-200 sm:w-40 ${
              isActive
                ? 'border-info-300 scale-105 border shadow-[0px_12px_16px_-8px_#0000001F]'
                : 'hover:border-info-300 border-white shadow-[0px_4px_10px_0px_#0000001A]'
            }`}
          >
            <div className="bg-surface-light rounded-lg p-2">
              <R2Image
                path={icon}
                alt=""
                width={32}
                height={32}
                className="h-8 w-8 object-contain"
              />
            </div>
            <span
              className={`text-base font-semibold ${
                isActive ? 'text-theme-primary' : 'text-royal-700'
              }`}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ScanCategoryTabs;
